export const PROPERTY_TYPES = [
  { value: 'house', label: 'House' },
  { value: 'apartment', label: 'Apartment' },
  { value: 'condo', label: 'Condo' },
  { value: 'townhome', label: 'Townhome' },
  { value: 'other', label: 'Other' },
];
export const SQFT_RANGES = [
  { value: 'under_1000', label: 'Under 1,000 sq ft' },
  { value: '1000_1500', label: '1,000 – 1,500' },
  { value: '1500_2000', label: '1,500 – 2,000' },
  { value: '2000_2500', label: '2,000 – 2,500' },
  { value: '2500_3500', label: '2,500 – 3,500' },
  { value: 'over_3500', label: '3,500+' },
  { value: 'unsure', label: 'Other / Not sure' },
];
export const PETS = [
  { value: 'none', label: 'None' },
  { value: 'dog', label: 'Dog' },
  { value: 'cat', label: 'Cat' },
  { value: 'multiple', label: 'Multiple' },
];
export const PARKING = [
  { value: 'driveway', label: 'Driveway' },
  { value: 'street', label: 'Street parking' },
  { value: 'complex', label: 'Apartment / complex parking' },
  { value: 'garage', label: 'Garage' },
  { value: 'paid', label: 'Paid parking' },
  { value: 'other', label: 'Other' },
];
export const GOALS = [
  { value: 'whole_home_reset', label: 'Whole-Home Reset', desc: 'I want everything brought back under control.' },
  { value: 'routine', label: 'Routine Cleaning', desc: 'The home is maintained and I need help keeping it that way.' },
  { value: 'move_in_out', label: 'Move-In / Move-Out', desc: 'The space needs to be prepared for a transition.' },
  { value: 'problem_areas', label: 'Specific Problem Areas', desc: 'Most of the space is fine, but certain areas need extra attention.' },
];
export const AREAS = [
  { value: 'kitchen', label: 'Kitchen' },
  { value: 'bathrooms', label: 'Bathrooms' },
  { value: 'floors', label: 'Floors' },
  { value: 'bedrooms', label: 'Bedrooms' },
  { value: 'living_areas', label: 'Living Areas' },
  { value: 'dusting', label: 'Dusting' },
  { value: 'baseboards', label: 'Baseboards' },
  { value: 'pet_hair', label: 'Pet Hair' },
  { value: 'other', label: 'Other' },
];
export const SOMEONE_HOME = [
  { value: 'yes_me', label: "Yes, I'll be home" },
  { value: 'someone_else', label: 'Someone else will be home' },
  { value: 'empty', label: 'No, the space will be empty' },
];
export const ACCESS = [
  { value: 'key', label: 'Key' },
  { value: 'lockbox', label: 'Lockbox' },
  { value: 'door_code', label: 'Door code' },
  { value: 'let_in', label: 'Someone will let us in' },
  { value: 'other', label: 'Other' },
];

export const label = (list, value) => list.find(o => o.value === value)?.label || (value ? String(value) : '—');

export const STAGES = ['Your Space', 'Needs', 'Details', 'Review'];
// screen index -> stage index
export const SCREENS = [
  { key: 'address', stage: 0 }, { key: 'property', stage: 0 }, { key: 'parking', stage: 0 },
  { key: 'goal', stage: 1 }, { key: 'areas', stage: 1 },
  { key: 'photos', stage: 2 }, { key: 'access', stage: 2 }, { key: 'home', stage: 2 },
  { key: 'review', stage: 3 },
];

export const EMPTY_DATA = {
  address: { line1: '', line2: '', city: '', state: '', zip: '' },
  property_type: null, square_footage: null, bedrooms: 2, bathrooms: 1, floors: 1,
  occupancy: null, pets: null, parking: null, parking_notes: '',
  primary_goal: null, priority_areas: [], concerns: '',
  someone_home: null, access_method: null, entry_instructions: '',
  pet_instructions: '', no_enter_areas: '', special_surfaces: '',
};

export const cleanForServer = (d) => {
  const out = {};
  Object.entries(d).forEach(([k, v]) => {
    if (v === null || v === undefined || v === '') return;
    out[k] = v;
  });
  return out;
};
